import { render, staticRenderFns } from "./PtoDelegate.vue?vue&type=template&id=5ba0209c&scoped=true"
import script from "./PtoDelegate.vue?vue&type=script&lang=js"
export * from "./PtoDelegate.vue?vue&type=script&lang=js"
import style0 from "./PtoDelegate.vue?vue&type=style&index=0&id=5ba0209c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba0209c",
  null
  
)

export default component.exports